import { Link } from "react-router-dom";
import { MaskLines, Reveal } from "@/components/Motion";
import { OCCASIONS } from "@/data/site";

export const CustomTeaser = () => (
  <section data-testid="custom-orders-section" className="bg-linen">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-28 md:py-44">
      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <p className="eyebrow mb-6">Custom Orders</p>
          <MaskLines lines={["Made for", <span className="italic text-mocha">your moment.</span>]} className="font-display font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.95]" />
          <Reveal delay={0.1}>
            <p className="mt-8 text-mocha leading-relaxed max-w-md text-base md:text-lg">
              Custom cupcakes, cookies and dessert orders are available for birthdays, celebrations, showers, corporate events and every special occasion in between.
            </p>
            <Link to="/custom-orders" data-testid="custom-section-cta" className="btn btn-dark mt-10">Begin a Custom Order</Link>
          </Reveal>
        </div>
        <ul className="lg:col-span-6 lg:col-start-7 border-t border-espresso/15">
          {OCCASIONS.map((o, i) => (
            <Reveal key={o} delay={i * 0.06}>
              <li className="flex items-baseline justify-between py-6 border-b border-espresso/15">
                <span className="font-display text-3xl md:text-4xl">{o}</span>
                <span className="text-xs tracking-[0.2em] text-mocha">{String(i + 1).padStart(2, "0")}</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
